export enum DateFormatKeys {
  TwoDigitLeadingZeroMonth = 'twoDigitLeadingZeroMonth',
  CompactMonth = 'compactMonth',
  TwoDigitLeadingZeroDay = 'twoDigitLeadingZeroDay',
  CompactDay = 'compactDay',
  TwoDigitYear = 'twoDigitYear',
  FourDigitYear = 'fourDigitYear'
}

export const DateFormats: Record<DateFormatKeys, RegExp> = {
  [DateFormatKeys.TwoDigitLeadingZeroMonth]: /^0[1-9]$|^1[012]$/,
  [DateFormatKeys.CompactMonth]: /^0?[1-9]$|^1[012]$/,
  [DateFormatKeys.TwoDigitLeadingZeroDay]: /^0[1-9]$|^[12][0-9]$|^3[01]$/,
  [DateFormatKeys.CompactDay]: /^0?[1-9]$|^[12][0-9]$|^3[01]$/,
  [DateFormatKeys.TwoDigitYear]: /^\d{2}$/,
  [DateFormatKeys.FourDigitYear]: /^(19|20)\d{2}$/,
};
